<template>
  <div id="base">
    <notifications group="notification" />
    <Registration/>
  </div>
</template>

<script>
import Registration from './components/Registration.vue'

export default {
  name: 'Base',
  components: {
    Registration
  }
}
</script>

<style>
</style>
